import { RouteTypes } from 'consts';
import { nomPaginaIH } from 'pages/ReportHours';
import { nomPaginaIHI } from 'pages/ReportInfrastructure';

import { useEffect, useMemo, useRef } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import { makeSelectAlumnosInformesParsed, makeSelectCursosInformesParsed, makeSelectEstadosInformesParsed, makeSelectProvinciasInformesParsed, makeSelectSociedadesInformesParsed } from 'store/informes/selectors';
import { editarFiltroRequest, eliminarFiltroRequest, guardarFiltroRequest, removeFiltro, setFiltroFechaCreacion, setFiltroFechaModificacion, setFiltroId, setFiltroJson, setFiltroNombre, setFiltroNombrePagina } from 'store/usuarios/actions';
import { makeSelectFiltros, makeSelectNombreFiltro, makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import {
  getActualTime,
  getTodayFinishDate,
  getTodayMinusOneMonthStartDate,
  getTodayMinusOneYearStartDate,
} from 'utils/dates-validators';
import { formatDateMax } from 'utils/dateTimeUtils';
import { arrayToAPI } from 'utils/listUtils';
import { deleteSavedPagination } from 'utils/practiceUtils';

interface InformesFilterModel {
  fechaInicio?: string;
  fechaFin?: string;
  sociedades?: string;
  estadosCurso?: string;
  cursos?: string;
  provincias?: string;
}

interface InformesFilterActions {
  sociedades: Function;
  provincias: Function;
  cursos: Function;
  estados: Function;
  alumnos: Function;
  filtros: Function;
  removeFiltros: Function;
}

const selectors = createStructuredSelector({
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  filtro: makeSelectFiltros(),
  nombreFiltro: makeSelectNombreFiltro(),
  sociedadesFiltro: makeSelectSociedadesInformesParsed(),
  provinciasFiltro: makeSelectProvinciasInformesParsed(),
  estadosFiltro: makeSelectEstadosInformesParsed(),
  cursosFiltro: makeSelectCursosInformesParsed(),
  alumnosFiltro: makeSelectAlumnosInformesParsed(),
} as any);

export const useInformesFilter = (
  actions: InformesFilterActions,
  initFilter: InformesFilterModel = {}
) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    profileActive,
    filtro,
    nombreFiltro,
    sociedadesFiltro,
    provinciasFiltro,
    estadosFiltro,
    cursosFiltro,
    alumnosFiltro,
  } = useSelector<any, any>(selectors);

  const baseFilter = {
    fechaInicio:
      (profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611' || profileActive?.ID_PERFIL === '711')
        ? getTodayMinusOneMonthStartDate().toString()
        : getTodayMinusOneYearStartDate().toString(),
    fechaFin: getTodayFinishDate(),
    sociedades: '',
    estadosCurso: '',
    cursos: '',
    provincias: '',
    alumnos: '',
  };

  const [selectedSociedades, setSelectedSociedades]: [any, any] = useState('');
  const [selectedProvincias, setSelectedProvincias]: [any, any] = useState('');
  const [selectedEstados, setSelectedEstados]: [any, any] = useState('');
  const [selectedCursos, setSelectedCursos]: [any, any] = useState('');
  const [selectedAlumnos, setSelectedAlumnos]: [any, any] = useState('');
  const [selectedFechaDesde, setSelectedFechaDesde]: [any, any] = useState(
    initFilter.fechaInicio ||
    ((profileActive?.ID_PERFIL === '511'  || profileActive?.ID_PERFIL === '611' || profileActive?.ID_PERFIL === '711')
      ? getTodayMinusOneMonthStartDate().toString()
      : getTodayMinusOneYearStartDate().toString())
  );
  const [selectedFechaHasta, setSelectedFechaHasta]: [any, any] = useState(
    initFilter.fechaFin || getTodayFinishDate()
  );

  const [filter, setFilter]: any = useState({ ...baseFilter, ...initFilter });

  const filterRef: any = useRef({});
  useEffect(() => {
    filterRef.current = filter;
  }, [filter])

  const handleSelectedSociedad = (e) => {
    const sociedades = arrayToAPI(e.detail);
    const newFilter = {
      ...filter,
      sociedades,
      provincias: '',
      cursos: '',
      alumnos: '',
    };

    setSelectedSociedades(JSON.stringify(e.detail));

    setFilter(newFilter);
    setSelectedProvincias('[]');
    setSelectedCursos('[]');
    setSelectedAlumnos('[]');

    dispatch(actions.provincias({ sociedades }));
    dispatch(actions.cursos({ sociedades }));
    dispatch(actions.alumnos({ sociedades }));
  };

  const handleSelectedProvincia = (e) => {
    const provincias = arrayToAPI(e.detail);
    const newFilter = { ...filter, provincias, cursos: '', alumnos: '' };

    setSelectedProvincias(JSON.stringify(e.detail));

    setFilter(newFilter);
    setSelectedCursos('[]');
    setSelectedAlumnos('[]');

    dispatch(actions.cursos({ sociedades: newFilter.sociedades, provincias }));
    dispatch(actions.alumnos({ sociedades: newFilter.sociedades, provincias }));
  };

  const handleSelectedEstado = (e) => {
    const estadosCurso = arrayToAPI(e.detail);
    const newFilter = {...filter,estadosCurso,cursos: '',alumnos: ''};

    setSelectedEstados(JSON.stringify(e.detail));

    setFilter(newFilter);
    setSelectedCursos('[]');
    setSelectedAlumnos('[]');

    dispatch(
      actions.cursos({
        sociedades: newFilter.sociedades,
        provincias: newFilter.provincias,
        estadosCurso,
      })
    );
    dispatch(
      actions.alumnos({
        sociedades: newFilter.sociedades,
        provincias: newFilter.provincias,
      })
    );
  };

  const isAllSelected = (selected: any[], options: any): boolean => {
    let parsedOptions = options;

    if (typeof options === 'string') {
      try {
        parsedOptions = JSON.parse(options);
      } catch {
        return false;
      }
    }

    return (
      Array.isArray(parsedOptions) &&
      parsedOptions.length > 0 &&
      selected.length === parsedOptions.length
    );
  };

    const handleSelectedCursos = (e) => {
      const selected = e.detail ?? [];

      const cursos = isAllSelected(selected, cursosFiltro)
        ? ''
        : arrayToAPI(selected);

      const newFilter = {
        ...filter,
        cursos,
        alumnos: '',
      };

      setSelectedCursos(JSON.stringify(selected));

      setFilter(newFilter);
      setSelectedAlumnos('[]');

      dispatch(
        actions.alumnos({
          sociedades: newFilter.sociedades,
          provincias: newFilter.provincias,
          cursos,
        })
      );
    };

const handleSelectedAlumnos = (e) => {
    const selected = e.detail ?? [];

    const alumnos = isAllSelected(selected, alumnosFiltro)
      ? ''
      : arrayToAPI(selected);

    setSelectedAlumnos(JSON.stringify(selected));

    const newFilter = {
      ...filter,
      alumnos,
    };

    /*
    * Miramos selectedCursos y no filter.cursos,
    * filter.cursos === '' puede significar:
    * - ningun curso seleccionado
    * - todos los cursos seleccionados
    */
    let cursosSeleccionados = [];

    try {
      cursosSeleccionados =
        typeof selectedCursos === 'string'
          ? JSON.parse(selectedCursos || '[]')
          : selectedCursos;
    } catch {
      cursosSeleccionados = [];
    }

    const hayCursosSeleccionados =
      Array.isArray(cursosSeleccionados) &&
      cursosSeleccionados.length > 0;

    if (!hayCursosSeleccionados) {
      dispatch(
        actions.cursos({
          sociedades: newFilter.sociedades,
          provincias: newFilter.provincias,
          alumnos,
        })
      );
    }

    setFilter(newFilter);
  };

  const handleSelectedFechaDesde = (e) => {
    setSelectedFechaDesde(e.detail);

    setFilter({ ...filter, fechaInicio: e.detail });
  };

  const handleSelectedFechaHasta = (e) => {
    const sumDay = Number(e.detail) /* + 86400000 */;
    setSelectedFechaHasta(formatDateMax(e.detail));

    setFilter({ ...filter, fechaFin: formatDateMax(sumDay) });
  };

  const cleanFilters = () => {
    deleteSavedPagination(window.location.pathname);
    dispatch(actions.removeFiltros());
    setSelectedOptionFilter(false);
    setIsFilterActive(false);
    setSelectedSociedades('[]');
    setSelectedProvincias('[]');
    setSelectedEstados('[]');
    setSelectedCursos('[]');
    setSelectedAlumnos('[]');
    setSelectedFiltros('[]');
    setSelectedFechaDesde(
      initFilter.fechaInicio ??
      ((profileActive?.ID_PERFIL === '511' || profileActive?.ID_PERFIL === '611' || profileActive?.ID_PERFIL === '711')
        ? getTodayMinusOneMonthStartDate().toString()
        : getTodayMinusOneYearStartDate().toString())
    );
    setSelectedFechaHasta(initFilter.fechaFin ?? getTodayFinishDate());

    setFilter({ ...baseFilter, ...initFilter });

    setOptionsFilter('');
    setSelectedFilter({});
    setSelectedFilterName('');
    setSelectedFilterId('');

    dispatch(actions.sociedades({}));
    dispatch(actions.provincias({}));
    dispatch(actions.estados({}));
    dispatch(actions.cursos({}));
    dispatch(actions.alumnos({}));
    dispatch(actions.filtros());
  };

  useEffect(() => {
    if (profileActive) {

      dispatch(actions.sociedades({}));
      dispatch(actions.provincias({}));
      dispatch(actions.estados({}));
      dispatch(actions.cursos({}));
      dispatch(actions.alumnos({}));
    }
  }, [profileActive]);

  useEffect(() => {
    return () => {
      dispatch(actions.removeFiltros());
    };
  }, []);

  //Filtro

  const [selectedFiltros, setSelectedFiltros]: [any, any] = useState('');
  const [selectedFilterName, setSelectedFilterName] = useState('');
  const [modalCerradoFiltroGuardarType, setModalCerradoFiltroGuardarType] = useState('');
  const [modalCerradoFiltroEliminarType, setModalCerradoFiltroEliminarType] = useState('');
  const [modalCerradoFiltroEditarType, setModalCerradoFiltroEditarType] = useState('');
  const [selectedFilterId, setSelectedFilterId] = useState('');
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [minDateFromFilter, setMinDateFromFilter] = useState('');
  const [maxDateFromFilter, setMaxDateFromFilter] = useState('');
  const [optionsFilter, setOptionsFilter] = useState('');
  const [selectedFilter, setSelectedFilter] = useState({});
  const [selectedOptionFilter, setSelectedOptionFilter] = useState(false);

  const filterNameAdd: boolean = useMemo(() => {
    return !!nombreFiltro;
  }, [nombreFiltro]);

  const parseOptions = (raw: any): any[] => {
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  const buildActiveOptions = (
    source: any[],
    selectedCsv: string,
    getValue: (item: any) => string,
    buildFallback: (id: string, item: any) => any,
    avoidFallbackDuplicates = true
  ) => {
    const selectedIds = (selectedCsv || '').split(',');
    const uniqueValues = new Set<string>();

    const updated = Array.isArray(source)
      ? source
          .filter((item) => selectedIds.includes(getValue(item)))
          .filter((item) => {
            const value = getValue(item);
            if (uniqueValues.has(value)) {
              return false;
            }
            uniqueValues.add(value);
            return true;
          })
          .map((item) => ({
            ...item,
            active: 'true',
          }))
      : [];

    selectedIds.forEach((id: string) => {
      if (!avoidFallbackDuplicates || !updated.some((item) => item.value === id)) {
        const item = source.find((option) => getValue(option) === id);
        if (item) {
          updated.push(buildFallback(id, item));
        }
      }
    });

    return updated;
  };

  const handleSelectedFiltros = (e: any) => {
  setSelectedOptionFilter(true);
  setIsFilterActive(true);

  const filtroSeleccionado = e.detail;
  setSelectedFilterName(filtroSeleccionado.label);
  setSelectedFilterId(filtroSeleccionado.label.split(' - ')[0]);

  const filtroValue = JSON.parse(filtroSeleccionado.value);

  setSelectedFilter({
    sociedades: filtroValue.sociedades,
    provincias: filtroValue.provincias,
    estados: filtroValue.estados,
    estadosCurso: filtroValue.estadosCurso,
    cursos: filtroValue.cursos,
    alumnos: filtroValue.alumnos,
    fechaInicio: filtroValue.fechaInicio,
    fechaFin: filtroValue.fechaFin,
  });

  const parsedSociedades = parseOptions(sociedadesFiltro);
  const parsedProvincias = parseOptions(provinciasFiltro);
  const parsedEstados = parseOptions(estadosFiltro);
  const parsedCursos = parseOptions(cursosFiltro);
  const parsedAlumnos = parseOptions(alumnosFiltro);

  const updatedSociedades = buildActiveOptions(
    parsedSociedades,
    filtroValue.sociedades,
    (sociedad) => sociedad.value.toString(),
    (sociedadId, sociedadPractica) => ({
      label: `${sociedadId} - ${sociedadPractica.label.split(' - ')[0]}`,
      value: sociedadId,
      active: 'true',
    })
  );

  const updatedProvincias = buildActiveOptions(
    parsedProvincias,
    filtroValue.provincias,
    (provincia) => provincia.value,
    (provinciaId, provinciaPractica) => ({
      label: provinciaPractica.label,
      value: provinciaId,
      active: 'true',
    })
  );

  const estadosCurso = filtroValue.estadosCurso || '';
  const updatedEstados = estadosCurso
    ? buildActiveOptions(
        parsedEstados,
        estadosCurso,
        (estado) => estado.value,
        (estadoId, estadoPractica) => ({
          label: estadoPractica.label,
          value: estadoId,
          active: 'true',
        })
      )
    : [];

  const updatedCursos = buildActiveOptions(
    parsedCursos,
    filtroValue.cursos,
    (curso) => curso.value.toString(),
    (cursoId, cursoPractica) => ({
      label: `${cursoId} - ${cursoPractica.label.split(' - ')[1]}`,
      value: cursoId,
      active: 'true',
    })
  );

  const updatedAlumnos = buildActiveOptions(
    parsedAlumnos,
    filtroValue.alumnos,
    (alumno) => alumno.value.toString(),
    (alumnoId, alumnoPractica) => ({
      label: `${alumnoId} - ${alumnoPractica.label.split(' - ')[0]}`,
      value: alumnoId,
      active: 'true',
    }),
    false
  );

  const minDateFromFilter = filtroValue.fechaInicio;
  const maxDateFromFilter = filtroValue.fechaFin;

  const combinedOptions = [
    ...updatedSociedades,
    ...updatedProvincias,
    ...updatedEstados,
    ...updatedCursos,
    ...updatedAlumnos,
    minDateFromFilter,
    maxDateFromFilter,
  ];

  setOptionsFilter(JSON.stringify(combinedOptions));
  setMinDateFromFilter(minDateFromFilter);
  setMaxDateFromFilter(maxDateFromFilter);
  setIsFilterActive(true);

  setFilter({
    ...selectedFilter,
    sociedades: filtroValue.sociedades,
    provincias: filtroValue.provincias,
    estados: filtroValue.estados,
    estadosCurso: filtroValue.estadosCurso,
    cursos: filtroValue.cursos,
    alumnos: filtroValue.alumnos,
    fechaInicio: filtroValue.fechaInicio,
    fechaFin: filtroValue.fechaFin,
  });
};

  const openModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('empty');
  }

  const closeModalGuardarFiltroCerrado = () => {
    setModalCerradoFiltroGuardarType('');
  };

  const handleClickConfirmFilterButton = () => {
    const filtroDatos = filter;
    let nombrePag;
    if (window.location.pathname === RouteTypes.REPORT_INFRAESTRUCTURE) {
      nombrePag = nomPaginaIHI;
    } else if (window.location.pathname === RouteTypes.REPORT_HOURS) {
      nombrePag = nomPaginaIH;
    }
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    dispatch(guardarFiltroRequest(pagina, filtroJson));

    switch (window.location.pathname) {
      case `${RouteTypes.REPORT_INFRAESTRUCTURE}`:
        history.push(RouteTypes.AUDIT);
        history.push(RouteTypes.REPORT_INFRAESTRUCTURE);
        break;
      case `${RouteTypes.REPORT_HOURS}`:
        history.push(RouteTypes.AUDIT);
        history.push(RouteTypes.REPORT_HOURS)
        break;
      default:
        break;
    }
  };

  const handleChangeFiltroNombre = (e: string) => {
    dispatch(setFiltroNombre(e));
  };


  //Editar filtro
  const openModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('confirm');
  };

  const closeModalEditarFiltroCerrado = () => {
    setModalCerradoFiltroEditarType('');
  };

  const confirmModalEditarFiltroCerrado = (filterName: string) => {
    handleClickEditarFiltroButton(filterName);
  };

  const handleClickEditarFiltroButton = (filterName: string) => {
    setModalCerradoFiltroEditarType('');
    const currentUrl = window.location.pathname;
    const filtroDatos = filter;
    const filtroIdString = String(selectedFilterId);

    let nombrePag;
    if (currentUrl === RouteTypes.REPORT_INFRAESTRUCTURE) {
      nombrePag = nomPaginaIHI;
    } else if (currentUrl === RouteTypes.REPORT_HOURS) {
      nombrePag = nomPaginaIH;
    }
    const pagina = dispatch(setFiltroNombrePagina(nombrePag));
    const filtroJson = dispatch(setFiltroJson(filtroDatos));
    const nombreFiltro = filterName.split(' - ')[1];
    const filtroSeleccionado = filtro.find(filtro => filtro.NOMBRE_FILTRO === nombreFiltro);
    const fechaCreacion = filtroSeleccionado.FECHA_CREACION;
    const fechaModificacion = getActualTime();

    dispatch(setFiltroNombre(nombreFiltro));
    dispatch(setFiltroId(filtroIdString));
    dispatch(setFiltroFechaCreacion(fechaCreacion));
    dispatch(setFiltroFechaModificacion(fechaModificacion));
    dispatch(editarFiltroRequest(filtroJson, pagina));

    switch (currentUrl) {
      case `${RouteTypes.REPORT_INFRAESTRUCTURE}`:
        history.push(RouteTypes.AUDIT);
        history.push(RouteTypes.REPORT_INFRAESTRUCTURE);
        break;
      case `${RouteTypes.REPORT_HOURS}`:
        history.push(RouteTypes.AUDIT);
        history.push(RouteTypes.REPORT_HOURS);
        break;
      default:
        break;
    }
  }
  //Eliminar filtro
  const openModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('confirm');
  }

  const closeModalEliminarFiltroCerrado = () => {
    setModalCerradoFiltroEliminarType('');
  }

  const confirmModalEliminarFiltroCerrado = () => {
    handleClickEliminarFiltroButton();
  };

  const handleClickEliminarFiltroButton = () => {
    setModalCerradoFiltroEliminarType('');
    const filtroIdString = String(selectedFilterId);
    dispatch(setFiltroId(filtroIdString));
    dispatch(eliminarFiltroRequest(filtroIdString));
    switch (window.location.pathname) {
      case `${RouteTypes.REPORT_INFRAESTRUCTURE}`:
        history.push(RouteTypes.AUDIT);
        history.push(RouteTypes.REPORT_INFRAESTRUCTURE);
        break;
      case `${RouteTypes.REPORT_HOURS}`:
        history.push(RouteTypes.AUDIT);
        history.push(RouteTypes.REPORT_HOURS)
        break;
      default:
        break;
    }
  }

  return {
    filter,
    setFilter,
    selectedSociedades,
    selectedProvincias,
    selectedEstados,
    selectedCursos,
    selectedFechaDesde,
    selectedFechaHasta,
    selectedAlumnos,
    setSelectedEstados,
    handleSelectedSociedad,
    handleSelectedProvincia,
    handleSelectedFechaDesde,
    handleSelectedFechaHasta,
    handleSelectedEstado,
    handleSelectedCursos,
    handleSelectedAlumnos,
    cleanFilters,
    //Filtros
    filterNameAdd,
    selectedFiltros,
    selectedFilterName,
    modalCerradoFiltroGuardarType,
    modalCerradoFiltroEliminarType,
    modalCerradoFiltroEditarType,
    isFilterActive,
    minDateFromFilter,
    maxDateFromFilter,
    optionsFilter,
    selectedOptionFilter,

    handleSelectedFiltros,
    openModalGuardarFiltroCerrado,
    closeModalGuardarFiltroCerrado,
    handleChangeFiltroNombre,
    handleClickConfirmFilterButton,
    openModalEliminarFiltroCerrado,
    closeModalEliminarFiltroCerrado,
    confirmModalEliminarFiltroCerrado,
    openModalEditarFiltroCerrado,
    confirmModalEditarFiltroCerrado,
    closeModalEditarFiltroCerrado,
  };
};
